import ReferralAccordion from "./ReferralAccordion.js";

const App = () => <ReferralAccordion />;

export default App;
